import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import { updateUser, clearCache } from "../actions/user";
import { fetchUpdates } from "../actions/sync";
import { PageContainer } from "../styles/common";

import Button from "../components/Button";
import Checkbox from "../components/Checkbox";
import ChangeUserImage from "./ChangeUserImage";

const mapStateToProps = (state) => ({
  user: state.user,
});

const mapDispatchToProps = (dispatch) => ({
  updateWeeklyEventsEmail: (event) =>
    dispatch(
      updateUser({
        weeklyEventsEmail: event.target.checked,
      }),
    ),
  clearCache: () => dispatch(clearCache()),
  fetchUpdates: () => dispatch(fetchUpdates()),
});

const Settings = (state) => {
  const { user, updateWeeklyEventsEmail, clearCache, fetchUpdates } = state;

  // Update page title
  useEffect(() => {
    const previous = document.title;
    document.title = "Settings - Humans.io";
    return () => {
      document.title = previous;
    };
  }, []);

  const onClearCache = async () => {
    localStorage.clear();
    await clearCache();
    await fetchUpdates();
    alert("The cache was successfully cleared.");
  };

  return (
    <PageContainer>
      <div className="mt-3 px-3">
        <h1 className="text-xl">Account Settings for {user.email}</h1>
        <div className="mt-3">
          <p className="text-sm">Update Account Email</p>
          <div>
            <Link to="/change-email">
              <Button className="mt-1" type="button">
                Change Email
              </Button>
            </Link>
          </div>
        </div>

        <div className="mt-3">
          <p className="text-sm">Update Account Password</p>
          <div>
            <Link to="/change-password">
              <Button className="mt-1" type="button">
                Change Password
              </Button>
            </Link>
          </div>
        </div>

        <div className="mt-3">
          <p className="text-sm">Update Profile Photo</p>
          <div>
            <ChangeUserImage />
          </div>
        </div>

        <div className="mt-3">
          <p className="text-sm">Download Your Humans</p>
          <div>
            <a href="/api/backup.txt" target="_blank" rel="noopener noreferrer">
              <Button className="mt-1" type="button">
                TXT Backup
              </Button>
            </a>{" "}
            <a
              href="/api/backup.json"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button className="mt-1" type="button">
                JSON Backup
              </Button>
            </a>
          </div>
        </div>

        <div className="mt-3">
          <p className="text-sm">Clear Browser Cache (advanced)</p>
          <div>
            <Button
              onClick={() => onClearCache()}
              className="mt-1"
              type="button"
            >
              Clear Cache
            </Button>
          </div>
        </div>

        <div className="mt-3">
          <p className="text-sm">Notifications</p>

          <div className="mt-1 relative flex items-start">
            <div className="flex items-center h-5">
              <Checkbox
                onChange={updateWeeklyEventsEmail}
                checked={user.weeklyEventsEmail}
                id="candidates"
                name="candidates"
                type="checkbox"
              />
            </div>
            <div className="ml-2 text-sm">
              <p className="text-gray-500">
                {" "}
                Send me weekly emails with my humans' events
              </p>
            </div>
          </div>
        </div>
      </div>
    </PageContainer>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Settings);
